import React, { type ReactNode } from "react"
import { View } from "react-native"

interface DynamicColorCircleProps {
  color: string
  size?: number
  children: ReactNode
}

export const DynamicColorCircle = ({
  color,
  size = 40,
  children,
}: DynamicColorCircleProps) => {
  return (
    <View
      style={{
        backgroundColor: color,
        width: size,
        height: size,
        borderRadius: size / 2,
        justifyContent: "center",
        alignItems: "center",
        transform: [{ translateX: -size / 4 }],
      }}
    >
      {children}
    </View>
  )
}
